"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApparatusTypeEnum = void 0;
var ApparatusTypeEnum;
(function (ApparatusTypeEnum) {
    ApparatusTypeEnum[ApparatusTypeEnum["engine"] = 0] = "engine";
    ApparatusTypeEnum[ApparatusTypeEnum["ladder"] = 1] = "ladder";
    ApparatusTypeEnum[ApparatusTypeEnum["rescue"] = 2] = "rescue";
    ApparatusTypeEnum[ApparatusTypeEnum["tanker"] = 3] = "tanker";
    ApparatusTypeEnum[ApparatusTypeEnum["chief"] = 4] = "chief";
    ApparatusTypeEnum[ApparatusTypeEnum["quint"] = 5] = "quint";
    ApparatusTypeEnum[ApparatusTypeEnum["squad"] = 6] = "squad";
    ApparatusTypeEnum[ApparatusTypeEnum["medic"] = 7] = "medic";
    ApparatusTypeEnum[ApparatusTypeEnum["boat"] = 8] = "boat";
    ApparatusTypeEnum[ApparatusTypeEnum["atv"] = 9] = "atv";
    ApparatusTypeEnum[ApparatusTypeEnum["helicopter"] = 10] = "helicopter";
    ApparatusTypeEnum[ApparatusTypeEnum["command"] = 11] = "command";
    ApparatusTypeEnum[ApparatusTypeEnum["specops"] = 12] = "specops";
    ApparatusTypeEnum[ApparatusTypeEnum["airplane"] = 13] = "airplane";
    ApparatusTypeEnum[ApparatusTypeEnum["supervisor"] = 14] = "supervisor";
    ApparatusTypeEnum[ApparatusTypeEnum["hazmat"] = 15] = "hazmat";
    ApparatusTypeEnum[ApparatusTypeEnum["blsAmbulance"] = 16] = "blsAmbulance";
    ApparatusTypeEnum[ApparatusTypeEnum["alsAmbulance"] = 17] = "alsAmbulance";
    ApparatusTypeEnum[ApparatusTypeEnum["flycar"] = 18] = "flycar";
    ApparatusTypeEnum[ApparatusTypeEnum["truck"] = 19] = "truck";
    ApparatusTypeEnum[ApparatusTypeEnum["battalionChief"] = 20] = "battalionChief";
    ApparatusTypeEnum[ApparatusTypeEnum["battalionChiefReserve"] = 21] = "battalionChiefReserve";
    ApparatusTypeEnum[ApparatusTypeEnum["districtChief"] = 22] = "districtChief";
    ApparatusTypeEnum[ApparatusTypeEnum["other"] = 23] = "other";
})(ApparatusTypeEnum || (exports.ApparatusTypeEnum = ApparatusTypeEnum = {}));
//# sourceMappingURL=apparatusType.js.map